import { Markdown } from "@/components/markdown";

export function QuickstartPage({ lang }: { lang: "typescript" | "python" }) {
  return <Markdown path={`/quickstart-${lang}.md`} />;
}
